module.exports = __webpack_public_path__ + "static/media/me.a6ab69e7.png";